import { createIntl } from "react-intl";
import messages from "./data";
export const msgValus = Object.keys(messages).map((o) => messages[o]);
const intl = createIntl({ locale: "zh", messages });
export default intl;
